import { ReactNode } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { CookieConsentProvider } from "@/components/CookieConsent";
import ScrollManager from "@/components/ScrollManager";
import Seo from "@/components/Seo";
import Index from "./pages/Index";
import Betoninfos from "./pages/Betoninfos";
import Funktion from "./pages/Funktion";
import Impressum from "./pages/Impressum";
import Datenschutz from "./pages/Datenschutz";
import Cookies from "./pages/Cookies";
import NotFound from "./pages/NotFound";

export const AppProviders = ({ children }: { children: ReactNode }) => <>{children}</>;

export const RoutedApp = () => (
  <CookieConsentProvider>
    <Seo />
    <ScrollManager />
    <Routes>
      <Route path="/" element={<Index />} />
      <Route path="/funktion" element={<Funktion />} />
      <Route path="/betoninfos" element={<Betoninfos />} />
      <Route path="/impressum" element={<Impressum />} />
      <Route path="/datenschutz" element={<Datenschutz />} />
      <Route path="/cookies" element={<Cookies />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  </CookieConsentProvider>
);

const App = () => (
  <AppProviders>
    <BrowserRouter>
      <RoutedApp />
    </BrowserRouter>
  </AppProviders>
);

export default App;
